import BaseRepository, { PagedListResponse } from '@/repositories/base-repository';

import { SortType } from '@/transformers/sort-by';
import { LiveTemplate, LiveTemplate$Details } from '../types/LiveTemplate';

export interface LiveEventTemplatesQueryParams {
  q: string;
  count: number;
  offset: number;
  sortField: string;
  sortType: SortType;
}

export default class LiveEventTemplateRepository extends BaseRepository<
  LiveTemplate$Details,
  LiveEventTemplatesQueryParams,
  PagedListResponse<LiveTemplate>
> {
  constructor() {
    super('/live/eventTemplate');
  }

  public async removeSplash(templateId: string) {
    return this.undo(templateId, 'splash');
  }

  public uploadSplash(file: File, templateId: string) {
    return this._upload(file, `${templateId}/splash`);
  }
}
